// extracted by mini-css-extract-plugin
export var chip = "_fe-0";
export var filterDropdown = "_fe-5";
export var filterItem = "_fe-6";
export var icon = "_fe-1";
export var removeButton = "_fe-3";
export var removeIcon = "_fe-4";
export var separator = "_fe-2";